<script>
  import { Tooltip } from '@sveltestrap/sveltestrap';
  import { differenceInDays, formatDistanceToNowStrict } from 'date-fns';

  import { formatDate } from '@common/utils/dates';
  import { generateUUID } from '@common/utils/strings';

  export let row = {};

  const id = generateUUID();

  $: date = new Date(row.msgtime || row.utcts || row.lastactivity.utcts);
  $: days = !isNaN(date) && differenceInDays(new Date(), date);
</script>

<span>
  {#if !isNaN(date)}
    {#if days < 30}
      <span id="tooltip-sent-{id}">{formatDistanceToNowStrict(date, { addSuffix: true })}</span>
      <Tooltip target="tooltip-sent-{id}">
        {formatDate(date, 'M/d/yyyy @ h:mm a')}
      </Tooltip>
    {:else}
      {formatDate(date, 'M/d/yyyy')}
    {/if}
  {:else}
    -
  {/if}
</span>
